import { FirebaseError as FirebaseSDKError } from 'firebase/app';

export class FirebaseError extends Error {
  code?: string;
  
  constructor(message: string, code?: string) {
    super(message);
    this.name = 'FirebaseError';
    this.code = code;
  }
}

export function handleFirebaseError(error: unknown): FirebaseError {
  if (error instanceof FirebaseError) {
    return error;
  }

  if (error instanceof FirebaseSDKError) {
    return new FirebaseError(error.message, error.code);
  }
  
  const message = error instanceof Error ? error.message : 'An unknown error occurred';
  return new FirebaseError(message);
}

export function getErrorMessage(error: FirebaseError): string {
  switch (error.code) {
    case 'permission-denied':
      return 'You do not have permission to perform this action. Please sign in.';
    case 'not-found':
      return 'The requested resource was not found.';
    case 'already-exists':
      return 'This resource already exists.';
    default:
      return error.message;
  }
}